import React from 'react';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import {
    selectShortcutEditorData,
    setEditedShortcut,
    setDeletedShortcut,
    deleteShortcut,
    getShortcutDescription,
    selectRecordedShortcut,
    saveEditedShortcut,
} from 'modules/settings/stores/user-settings-slice-handler';
import store from 'modules/shared/stores/store';
import t from 'utils/translate';
import ConfirmationDialog from 'modules/shared/components/confirmation-dialog';
import SimpleModal from 'modules/shared/components/simple-modal';

function KeyboardShortcutEditor() {
    /**
     * @type {KeyboardShortcutEditorData}
     */
    const editorData = useSelector(selectShortcutEditorData);
    const recordedShortcut = useSelector(selectRecordedShortcut);

    if (editorData.editedShortcut === null && editorData.deletedShortcut === null) {
        return '';
    }

    const closeDialog = () => {
        store.dispatch(setDeletedShortcut(null));
    };

    // ask for delete shortcut confirmation
    if (editorData.deletedShortcut !== null) {
        return (
            <ConfirmationDialog
                closeCallback={() => closeDialog()}
                question={t('keyboard_shortcut_disable_confirmation').replace(
                    '%shortcutType',
                    t(`keyboard_shortcut_${editorData.deletedShortcut.type.toLowerCase()}_title`),
                )}
                yesCallback={() => {
                    closeDialog();
                    deleteShortcut(editorData.deletedShortcut);
                }}
                noCallback={() => closeDialog()}
            />
        );
    }

    // record a shortcut
    if (editorData.editedShortcut !== null) {
        const discardEdit = () => {
            store.dispatch(setEditedShortcut(null));
        };

        return (
            <SimpleModal
                className="shortcuts-dialog"
                dialogTitle={t('keyboard_shortcuts_title')}
                closeCallback={() => discardEdit()}
                buttons={
                    <>
                        <Button variant="contained" role="cancel" onClick={() => discardEdit()}>
                            {t('js_all_cancel')}
                        </Button>
                        <Button
                            variant="contained"
                            role="primary"
                            onClick={() => saveEditedShortcut()}
                            disabled={!editorData.canUseRecordedKey}
                        >
                            {t('js_all_save')}
                        </Button>
                    </>
                }
            >
                <div>{t('keyboard_shortcuts_record')}</div>
                <div className="wcf-ui-shortcut-details">{getShortcutDescription(recordedShortcut, true)}</div>
                {!editorData.canUseRecordedKey && recordedShortcut !== null && (
                    <div className="wcf-ui-error">{t('keyboard_shortcuts_error_in_use')}</div>
                )}
            </SimpleModal>
        );
    }

    return '';
}

export default KeyboardShortcutEditor;
